const ADJECTIVES = [
  'amber', 'brisk', 'calm', 'clever', 'cosmic', 'crisp', 'daring', 'eager', 'ember', 'gentle',
  'golden', 'happy', 'ivy', 'jolly', 'keen', 'lively', 'lucky', 'mellow', 'mighty', 'noble',
  'quick', 'radiant', 'sage', 'silken', 'spry', 'steady', 'stellar', 'sunny', 'swift', 'vivid',
];

const NOUNS = [
  'badger', 'beacon', 'brook', 'cedar', 'comet', 'falcon', 'forest', 'fox', 'harbor', 'hawk',
  'lynx', 'maple', 'meadow', 'otter', 'panda', 'phoenix', 'pine', 'raven', 'river', 'sparrow',
  'spruce', 'star', 'summit', 'trail', 'willow', 'wind', 'wolf', 'wren', 'zephyr', 'zinnia',
];

function hash32(input) {
  let hash = 0;
  const value = String(input || '');
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash << 5) - hash + value.charCodeAt(index)) | 0;
  }
  return Math.abs(hash >>> 0);
}

export function getGeneratedDisplayName(seed) {
  const baseHash = hash32(seed);
  const adjective = ADJECTIVES[baseHash % ADJECTIVES.length];
  const noun = NOUNS[Math.floor(baseHash / ADJECTIVES.length) % NOUNS.length];
  const suffix = (baseHash % 65536).toString(16).padStart(4, '0');
  return `${adjective}-${noun}-${suffix}`;
}
